import { defineStore } from 'pinia'

interface RegisterAddon {
  queries: Record<string, string>
}
const STORE_NAME = 'registerAddon'

export const useRegisterAddonStore = defineStore(STORE_NAME, {
  state: (): RegisterAddon => ({
    queries: {}
  }),
  persist: false,
  actions: {
    setRegisterAddon(data: Record<string, string>) {
      this.queries = data
    }
  }
})
